// extracted by mini-css-extract-plugin
export default {"innerVideo":"style_innerVideo__uWG3s","innerVideoIcon":"style_innerVideoIcon__S1ZTK"};